import { BadgeProps } from '../props';

export default function BadgeProgress({ reward }: BadgeProps) {
  return <>{reward?.lockedCounter + reward?.counter}</>;
}
